<!--流入明细-->
<template>
  <div>
    <tableCmp
      ref="tableCmp"
      :column-list="columnList"
      :end-time="queryForm.endTime"
      :is-select-btn="isSelectBtn"
      :start-time="queryForm.startTime"
      :table-data="tableData"
      :table-type="15"
      @selectionChange="selectionChange"
      @toInFlowSearch="getTableData"
    />
    <el-pagination
      :current-page.sync="pageNumber"
      :page-size.sync="pageSize"
      :page-sizes="[10, 50, 100, 200, 400]"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 20px 0; text-align: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
import {
  apiGetBagRecycleExportFlowDataSummary,
  apiGetBagRecycleFlowDataSummary
} from '@/api/newExpressAPI';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'InflowDetails',
  components: {
    tableCmp: () => import('./tableCmp.vue')
  },
  props: {
    queryForm: {
      type: Object,
      default() {
        return {
          justSearchCondition: null,
          returnWaybillNumberList: [], // 运单号
          startTime: '', // 起始日期
          endTime: '', // 结束日期
          returnSiteName: '',
          receiveSiteName: '',
          recycleStatus: null, // 是否确认
          waybillPrintStatus: null // 是否打印
        };
      }
    }
  },
  data() {
    return {
      total: 0,
      pageNumber: 1,
      pageSize: 10,
      isSelectBtn: false,
      tableData: [],
      selectArr: [],
      selectData: null,
      columnList: [
        {
          label: this.$t('GlobalSetObj.InflowBranch'),
          prop: 'targetSiteName',
          minWidth: '160px',
          align: 'center'
        }, // 流入网点
        {
          label: this.$t('GlobalSetObj.OutflowBranch'),
          prop: 'sentOutSiteName',
          minWidth: '160px',
          align: 'center'
        }, // 流出网点
        {
          label: this.$t('GlobalSetObj.InflowQuantity'),
          prop: 'flowCount',
          minWidth: '160px',
          align: 'center',
          isNewFlag: 2,
          isClick: true
        }, // 流入数量
        {
          label: this.$t('home.returned'),
          prop: 'returnedCount',
          minWidth: '160px',
          align: 'center',
          isNewFlag: 2,
          isClick: true
        }, // 已返还
        {
          label: this.$t('home.notReturned'),
          prop: 'unreturnedCount',
          minWidth: '160px',
          align: 'center',
          isNewFlag: 2,
          isClick: true
        }, // 未回收
        {
          label: this.$t('home.notReturnedTotal'),
          prop: 'unreturnedTotal',
          minWidth: '160px',
          align: 'center',
          isNewFlag: 2,
          isClick: true
        }, // 未回收总数
        {
          label: this.$t('home.pendingConfirmation'),
          prop: 'toBeConfirmedCount',
          minWidth: '160px',
          align: 'center',
          isNewFlag: 2,
          isClick: true
        } // 待确认
      ]
    };
  },
  created() {
    this.getTableData(this.queryForm);
  },
  methods: {
    // 数据勾选
    selectionChange(arr) {
      this.selectArr = arr;
      console.log(this.selectArr, '=this.selectArr');
    },
    // 获取列表数据
    getTableData(param) {
      const params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        params: {
          type: 'in',
          startTime: param.startTime,
          endTime: param.endTime,
          returnSiteName: param.returnSiteName,
          receiveSiteName: param.receiveSiteName,
          justSearchCondition: param.justSearchCondition
          // ...param
        }
      };
      console.log(params, '===params');
      apiGetBagRecycleFlowDataSummary(params).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 表格布局更新
    doLayout() {
      this.$refs.tableCmp.$refs.wovenBagManagementTable.doLayout();
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageNumber = 1;
      this.pageSize = val;
      this.getTableData(this.queryForm);
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getTableData(this.queryForm);
    },
    // 导出
    exportData(param) {
      console.log(param, '===param');
      const params = {
        type: 'in',
        startTime: param.startTime,
        endTime: param.endTime,
        returnSiteName: param.returnSiteName,
        receiveSiteName: param.receiveSiteName,
        justSearchCondition: param.justSearchCondition
      };
      apiGetBagRecycleExportFlowDataSummary(params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style scoped></style>
